import { styled, Stack, Link, Icons, Box } from '@/theme/index';

export const FlexContainer = styled('div')`
  display: flex;
`;

export const UnorderedList = styled('ul')(({ theme }) => ({
  listStyleType: 'none',
  padding: theme.spacing(0),
}));

export const ListItem = styled('li')`
  border-top: 2px solid #ebeaf4;
  font-size: 16px;
  position: relative;
`;

export const ListItemFlex = styled(ListItem)`
  display: flex;
`;

export const Wrapper = styled(Stack)(({ theme }) => ({
  '&:nth-of-type(even)': {
    backgroundColor: theme.palette.grey[100],
  },
  padding: theme.spacing(1.5),
  flexDirection: 'column',
  a: {
    marginTop: `${theme.spacing(1.5)} !important`,
  },
  [theme.breakpoints.up('sm')]: {
    flexDirection: 'row',
    alignItems: 'space-center',
    justifyContent: 'space-between',
    a: {
      margin: `${theme.spacing(0)} !important`,
    },
  },
}));

export const PropertySummaryWrapper = styled(Box)(() => ({
  borderTop: '2px solid #ebeaf4',
  margin: '24px 0',
  width: '100%',

  '& .MuiCard-root': {
    padding: 0,
    boxShadow: 'none',
  },
}));

export const PropertyLink = styled(Link)({
  cursor: 'pointer',
  textDecoration: 'none',
  fontSize: '1rem',
  fontWeight: 600,
  ':hover': {
    textDecoration: 'underline',
  },
});

export const StyledEditIcon = styled(Icons.Edit)(() => ({
  verticalAlign: 'middle',
  fontSize: '1.25rem',
  cursor: 'pointer',
}));
